import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCOverallVideosPhotosSharedByFellowsInWhatsApp = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Videos / Photos shared by fellows in WhatsApp" />
    </Box>
  );
};
